import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import { CALYPSO } from 'HubStyleTokens/colors';
import { Fragment } from 'react';
const TileWithLeftBorder = styled(UITile).withConfig({
  displayName: "ConditionalPropertiesPanelDependentSection__TileWithLeftBorder",
  componentId: "jgtab9-0"
})(["border-left:solid 5px ", ";"], CALYPSO);
const StyledDivWithBottomMargin = styled.div.withConfig({
  displayName: "ConditionalPropertiesPanelDependentSection__StyledDivWithBottomMargin",
  componentId: "jgtab9-1"
})(["&:not(:last-of-type){margin-bottom:12px !important;}"]);

const renderDependents = (dependents, path, passthroughProps) => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: dependents.map(dependent => /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(StyledDivWithBottomMargin, {
        "data-test-id": `${path}-${dependent.property.name}`,
        children: dependent.render(passthroughProps)
      }), renderDependents(dependent.dependents, `${path}-${dependent.property.name}`, passthroughProps)]
    }, `${path}-${dependent.property.name}`))
  });
};

function ConditionalPropertiesPanelDependentSection({
  input,
  passthroughProps
}) {
  return /*#__PURE__*/_jsx(TileWithLeftBorder, {
    compact: true,
    className: "m-top-4 m-bottom-2",
    "data-test-id": `${input.property.name}-dependents`,
    children: /*#__PURE__*/_jsx(UITileSection, {
      className: "p-top-2",
      children: renderDependents(input.dependents, input.property.name, passthroughProps)
    })
  });
}

export default ConditionalPropertiesPanelDependentSection;